/* Core & libraries */
import React, { useContext, createContext, useState } from "react";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
/* Styles */

const GlobalContext = createContext({});
const GlobalUpdateContext = createContext({});

export function useGlobalContext() {
  return useContext(GlobalContext);
}

export function useGlobalUpdateContext() {
  return useContext(GlobalUpdateContext);
}

export function GlobalProvider({ children }) {
  const [data, setData] = useState({});

  //context can store also functions, such as setters within the context itself
  const setGlobalProperties = (newData) => {
    setData(newData);
  };

  return (
    <GlobalContext.Provider value={data} displayName="GlobalStore">
      <GlobalUpdateContext.Provider value={setGlobalProperties} displayName="GlobalUpdateStore">
        {children}
      </GlobalUpdateContext.Provider>
    </GlobalContext.Provider>
  );
}
